import { useAppSelector } from 'app/hooks';
import Button, { ButtonWrapper } from 'blocks/Button';
import { Title } from 'blocks/Text';
import Form, { DatePicker } from 'components/Form';
import Modal from 'components/Modal';
import { ModalFC } from 'config/types';
import { resetFields } from 'helper/InputField';
import { getTimeStamp } from 'helper/date';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { isLTRState } from 'store/options/optionsSlice';
import * as S from './modalSearch.style';
import { ModalSearchFormModel, ModalSearchProps } from './modalsearch.interface';

const ModalSearch: ModalFC<ModalSearchProps> = ({ open, onClose, onSearch, onClearFilter }) => {
  const { t } = useTranslation();
  const { setValue, getValues } = useForm<ModalSearchFormModel>();
  const isLTR = useAppSelector(isLTRState);

  const handleSearch = () => {
    let params = '';

    const data = getValues();
    if (data.startDate) params += `&startDate=${getTimeStamp(data.startDate, 'YYYY-MM-DD')}`;
    if (data.endDate) params += `&endDate=${getTimeStamp(data.endDate, 'YYYY-MM-DD')}`;

    onSearch(params);
    onClose && onClose();
  };

  const handleClearFilter = () => {
    resetFields(['startDate', 'endDate'], setValue);

    onClearFilter();
    onClose && onClose();
  };

  return (
    <Modal open={open} onClose={onClose}>
      <S.ModalTitle>
        <Title>{t('pages.miles.view.sections.filters.fields.titleModal')} </Title>
      </S.ModalTitle>
      <Form>
        <S.Wrapper>
          <S.InputWrappers>
            <DatePicker
              dir={'ltr'}
              // control={register('startDate')}
              label={t('pages.miles.view.sections.filters.fields.startDate.label')}
              defaultValue={getValues('startDate')}
              onChange={(date) => setValue('startDate', date)}
            />
          </S.InputWrappers>
          <S.InputWrappers>
            <DatePicker
              dir={'ltr'}
              // control={register('endDate')}
              label={t('pages.miles.view.sections.filters.fields.endDate.label')}
              defaultValue={getValues('endDate')}
              onChange={(date) => {
                setValue('endDate', date);
              }}
            />
          </S.InputWrappers>
        </S.Wrapper>
        <S.ButtonWrapper as={ButtonWrapper} justify="flex-end">
          <S.Button as={Button} onClick={handleSearch}>
            {t('pages.miles.view.sections.filters.submitCTA')}
          </S.Button>
          <S.Button as={Button} color="outlined" onClick={handleClearFilter}>
            {t('pages.miles.view.sections.filters.clearCTA')}
          </S.Button>
        </S.ButtonWrapper>
      </Form>
    </Modal>
  );
};

export default ModalSearch;
